module.exports = "https://cdn.realtymogul.com/static/media/expand.85c31e94.svg";